import {Geofence} from "../../../model/geofence";
import {otsBaseApi} from "../../ots-api";
import {EntityIdentifier} from "../../../model/entity";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ["Geofences"]});

const geofenceApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getGeofencesByObject: builder.query<Geofence[], EntityIdentifier>({
      query: (eo) => ({
        url: '/geofences/object',
        method: 'GET',
        params: {id: eo.id, type: eo.type},
      }),
      providesTags: (result) => {
        if (result) {
          return [
            ...result.map(({id}) => ({type: 'Geofences', id} as const)),
            {type: 'Geofences', id: 'LIST'},
          ];
        } else {
          return [{type: 'Geofences', id: 'LIST'}];
        }
      },
    }),
    getGeofence: builder.query<Geofence, string>({
      query: (id) => ({
        url: `/geofences/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{type: 'Geofences', id}],
    }),
    createGeofence: builder.mutation<Geofence, Partial<Geofence>>({
      query: (mapping) => ({
        url: '/geofences',
        method: 'POST',
        body: mapping,
      }),
      invalidatesTags: [{type: 'Geofences', id: 'LIST'}],
    }),
    updateGeofence: builder.mutation<Geofence, Partial<Geofence>>({
      query: (mapping) => ({
        url: '/geofences',
        method: 'PUT',
        body: mapping,
      }),
      invalidatesTags: (result, error, {id}) => [{type: 'Geofences', id}],
    }),
    deleteGeofence: builder.mutation<Geofence, Partial<Geofence>>({
      query: (mapping) => ({
        url: `/geofences`,
        method: 'DELETE',
        body: mapping,
      }),
      invalidatesTags: (result, error, {id}) => [{type: 'Geofences', id}],
    }),
  }),
})

export const {
  useGetGeofencesByObjectQuery,
  useGetGeofenceQuery,
  useCreateGeofenceMutation,
  useUpdateGeofenceMutation,
  useDeleteGeofenceMutation,
} = geofenceApi;
